/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { InlineNotification } from 'carbon-addons-iot-react';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  type: PropTypes.string,
  data: PropTypes.shape({
    message: PropTypes.string.isRequired,
    details: PropTypes.string,
  }),
  onClose: PropTypes.func,
  className: PropTypes.string,
};

const defaultProps = {
  type: 'error',
  data: null,
  className: null,
  onClose: null,
};

/** simple component that wraps the notification box with a default type, and parses a data object,
 * maybe just use the Carbon notification component? */
const MessageBox = ({ type, data, onClose, className, ...other }) =>
  data ? (
    <InlineNotification
      title={data.message}
      subtitle={data.details || ''}
      kind={type || 'error'}
      onCloseButtonClick={onClose || undefined}
      className={className}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
    />
  ) : null;

MessageBox.propTypes = propTypes;
MessageBox.defaultProps = defaultProps;

export default MessageBox;
